let tms = {};

function timeout(key, ms, callback) {
	clearTimeout(tms[key]);

	tms[key] = setTimeout(() => {
		callback();
	}, ms);
}

export {timeout};
